
import { css } from 'lit';
export default css`
pc-form,
.pc-form{
  --background-color-input:transparent;
}

  pc-form .form-item, .pc-form .form-item{
    position:relative;
    margin-bottom:var(--spacing-8);
    font-family:var(--ff-body);
  }

  pc-form .form-item__description, .pc-form .form-item__description{
    color:var(--neutral-charcoal);
    margin-top:var(--spacing-1);
    font-size:var(--fs-sm);
  }

  pc-form .form-item:has(> input[type='radio']),
  pc-form .form-item:has(> input[type='checkbox']),
  .pc-form .form-item:has(> input[type='radio']),
  .pc-form .form-item:has(> input[type='checkbox']){
    margin-bottom:0.625rem;
  }

  pc-form .fieldset-legend, .pc-form .fieldset-legend{
    margin-top:var(--spacing-4);
    display:block;
  }

  pc-form legend,
  pc-form label,
  .pc-form legend,
  .pc-form label{
    display:block;
    margin-bottom:var(--spacing-3);
    font-size:1.125rem;
    line-height:224%;
    color:var(--purple-indigo);
    font-weight:var(--fw-normal);
    font-family:var(--ff-body);
  }

  pc-form .form-item:has(.error) label, .pc-form .form-item:has(.error) label{
    color:var(--primary-red);
  }

  pc-form ::placeholder, .pc-form ::placeholder{
    color:var(--neutral-medium-gray);
  }

  pc-form input[type='text'],
  pc-form input[type='email'],
  pc-form input[type='password'],
  pc-form input[type='url'],
  pc-form input[type='number'],
  pc-form input[type='date'],
  pc-form input[type='datetime-local'],
  pc-form input[type='month'],
  pc-form input[type='search'],
  pc-form input[type='tel'],
  pc-form input[type='time'],
  pc-form input[type='week'],
  pc-form textarea,
  pc-form select,
  .pc-form input[type='text'],
  .pc-form input[type='email'],
  .pc-form input[type='password'],
  .pc-form input[type='url'],
  .pc-form input[type='number'],
  .pc-form input[type='date'],
  .pc-form input[type='datetime-local'],
  .pc-form input[type='month'],
  .pc-form input[type='search'],
  .pc-form input[type='tel'],
  .pc-form input[type='time'],
  .pc-form input[type='week'],
  .pc-form textarea,
  .pc-form select{
    width:100%;
    padding:var(--spacing-3) var(--spacing-4);
    border-radius:8px;
    border:2px solid var(--purple-medium-neutral);
    background:var(--primary-white);
    color:var(--neutral-charcoal);
    transition:0.3s ease;
  }

  pc-form input[type='text']:hover, pc-form input[type='email']:hover, pc-form input[type='password']:hover, pc-form input[type='url']:hover, pc-form input[type='number']:hover, pc-form input[type='date']:hover, pc-form input[type='datetime-local']:hover, pc-form input[type='month']:hover, pc-form input[type='search']:hover, pc-form input[type='tel']:hover, pc-form input[type='time']:hover, pc-form input[type='week']:hover, pc-form textarea:hover, pc-form select:hover, .pc-form input[type='text']:hover, .pc-form input[type='email']:hover, .pc-form input[type='password']:hover, .pc-form input[type='url']:hover, .pc-form input[type='number']:hover, .pc-form input[type='date']:hover, .pc-form input[type='datetime-local']:hover, .pc-form input[type='month']:hover, .pc-form input[type='search']:hover, .pc-form input[type='tel']:hover, .pc-form input[type='time']:hover, .pc-form input[type='week']:hover, .pc-form textarea:hover, .pc-form select:hover{
      border:2px solid var(--purple-indigo);
    }

  pc-form input[type='text']:focus,
    pc-form input[type='text']:focus-visible,
    pc-form input[type='email']:focus,
    pc-form input[type='email']:focus-visible,
    pc-form input[type='password']:focus,
    pc-form input[type='password']:focus-visible,
    pc-form input[type='url']:focus,
    pc-form input[type='url']:focus-visible,
    pc-form input[type='number']:focus,
    pc-form input[type='number']:focus-visible,
    pc-form input[type='date']:focus,
    pc-form input[type='date']:focus-visible,
    pc-form input[type='datetime-local']:focus,
    pc-form input[type='datetime-local']:focus-visible,
    pc-form input[type='month']:focus,
    pc-form input[type='month']:focus-visible,
    pc-form input[type='search']:focus,
    pc-form input[type='search']:focus-visible,
    pc-form input[type='tel']:focus,
    pc-form input[type='tel']:focus-visible,
    pc-form input[type='time']:focus,
    pc-form input[type='time']:focus-visible,
    pc-form input[type='week']:focus,
    pc-form input[type='week']:focus-visible,
    pc-form textarea:focus,
    pc-form textarea:focus-visible,
    pc-form select:focus,
    pc-form select:focus-visible,
    .pc-form input[type='text']:focus,
    .pc-form input[type='text']:focus-visible,
    .pc-form input[type='email']:focus,
    .pc-form input[type='email']:focus-visible,
    .pc-form input[type='password']:focus,
    .pc-form input[type='password']:focus-visible,
    .pc-form input[type='url']:focus,
    .pc-form input[type='url']:focus-visible,
    .pc-form input[type='number']:focus,
    .pc-form input[type='number']:focus-visible,
    .pc-form input[type='date']:focus,
    .pc-form input[type='date']:focus-visible,
    .pc-form input[type='datetime-local']:focus,
    .pc-form input[type='datetime-local']:focus-visible,
    .pc-form input[type='month']:focus,
    .pc-form input[type='month']:focus-visible,
    .pc-form input[type='search']:focus,
    .pc-form input[type='search']:focus-visible,
    .pc-form input[type='tel']:focus,
    .pc-form input[type='tel']:focus-visible,
    .pc-form input[type='time']:focus,
    .pc-form input[type='time']:focus-visible,
    .pc-form input[type='week']:focus,
    .pc-form input[type='week']:focus-visible,
    .pc-form textarea:focus,
    .pc-form textarea:focus-visible,
    .pc-form select:focus,
    .pc-form select:focus-visible{
      outline:2px solid var(--purple-indigo);
      outline-offset:0;
      border-color:transparent;
    }

  pc-form input[type='text'].error, pc-form input[type='email'].error, pc-form input[type='password'].error, pc-form input[type='url'].error, pc-form input[type='number'].error, pc-form input[type='date'].error, pc-form input[type='datetime-local'].error, pc-form input[type='month'].error, pc-form input[type='search'].error, pc-form input[type='tel'].error, pc-form input[type='time'].error, pc-form input[type='week'].error, pc-form textarea.error, pc-form select.error, .pc-form input[type='text'].error, .pc-form input[type='email'].error, .pc-form input[type='password'].error, .pc-form input[type='url'].error, .pc-form input[type='number'].error, .pc-form input[type='date'].error, .pc-form input[type='datetime-local'].error, .pc-form input[type='month'].error, .pc-form input[type='search'].error, .pc-form input[type='tel'].error, .pc-form input[type='time'].error, .pc-form input[type='week'].error, .pc-form textarea.error, .pc-form select.error{
      outline:2px solid var(--primary-red);
      border-color:transparent;
    }

  pc-form .form-type--boolean, .pc-form .form-type--boolean{
    display:flex;
    align-items:center;
  }

  pc-form .form-type--boolean:has(> input[type='radio']), .pc-form .form-type--boolean:has(> input[type='radio']){
    display:inline-flex;
    margin-right:var(--spacing-10);
  }

  pc-form .form-type--boolean:has(> input[type='radio']):last-of-type, .pc-form .form-type--boolean:has(> input[type='radio']):last-of-type{
      margin-right:0;
    }

  pc-form input[type='checkbox'],
  pc-form input[type='radio'],
  .pc-form input[type='checkbox'],
  .pc-form input[type='radio']{
    width:14px;
    height:14px;
    margin-right:5.5px;
    -webkit-appearance:none;
            appearance:none;
  }

  pc-form input[type='checkbox'] + label, pc-form input[type='radio'] + label, .pc-form input[type='checkbox'] + label, .pc-form input[type='radio'] + label{
      display:inline-block;
      margin-bottom:0;
      font-weight:var(--fw-normal);
    }

  pc-form input[type='checkbox']:focus,
    pc-form input[type='checkbox']:focus-visible,
    pc-form input[type='radio']:focus,
    pc-form input[type='radio']:focus-visible,
    .pc-form input[type='checkbox']:focus,
    .pc-form input[type='checkbox']:focus-visible,
    .pc-form input[type='radio']:focus,
    .pc-form input[type='radio']:focus-visible{
      outline:2px solid var(--primary-eggplant);
      outline-offset:2px;
    }

  pc-form input[type='checkbox'],
  pc-form input[type='radio'],
  .pc-form input[type='checkbox'],
  .pc-form input[type='radio']{
    border:1px solid var(--primary-eggplant);
  }

  pc-form input[type='checkbox']:checked, pc-form input[type='radio']:checked, .pc-form input[type='checkbox']:checked, .pc-form input[type='radio']:checked{
      border:0;
      outline:1px solid var(--primary-eggplant);
      outline-offset:2.3px;
      background-color:var(--purple-indigo);
    }

  pc-form input[type='checkbox'], .pc-form input[type='checkbox']{
    border-radius:2x;
  }

  pc-form input[type='checkbox']:checked, .pc-form input[type='checkbox']:checked{
      border-radius:2px;
    }

  pc-form input[type='radio'], .pc-form input[type='radio']{
    border-radius:50%;
  }

  pc-form input[type='radio']:checked, .pc-form input[type='radio']:checked{
      border-radius:50%;
    }

  pc-form input[type='submit'], .pc-form input[type='submit']{
    background-color:var(--purple-indigo);
    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
    border:none;
    border-radius:8px;
    padding:12.5px var(--spacing-4);
    font-size:1.125rem;
    font-weight:500;
    color:var(--primary-white);
    font-weight:var(--fw-medium);
    font-family:var(--ff-body);
    text-decoration:none;
    transition:all ease 0.3s;
  }

  pc-form input[type='submit']:hover,
    pc-form input[type='submit']:focus,
    .pc-form input[type='submit']:hover,
    .pc-form input[type='submit']:focus{
      background-color:var(--primary-eggplant);
    }

  pc-form .error-message, .pc-form .error-message{
    margin-top:var(--spacing-3);
    color:var(--primary-red);
    font-size:var(--fs-sm);
    font-weight:var(--fw-normal);
    line-height:19px;
    letter-spacing:0em;
    text-align:left;
  }

  pc-form[hide-labels] label, .pc-form[hide-labels] label{
      position:absolute;
      width:1px;
      height:1px;
      padding:0;
      margin:-1px;
      overflow:hidden;
      clip:rect(0, 0, 0, 0);
      white-space:nowrap;
      border:0;
    }

  pc-form[form-type='search'] form, .pc-form[form-type='search'] form{
      position:relative;
    }

  pc-form[form-type='search'] .form-item, .pc-form[form-type='search'] .form-item{
      margin-bottom:0;
    }

  pc-form[form-type='search'] .js-form-item-search-api-fulltext, .pc-form[form-type='search'] .js-form-item-search-api-fulltext{
      background-color:var(--background-color-input);
      padding:var(--spacing-4);
    }

  @media (min-width: 992px){

  pc-form[form-type='search'] .js-form-item-search-api-fulltext, .pc-form[form-type='search'] .js-form-item-search-api-fulltext{
        padding:var(--spacing-12);
        display:flex;
        justify-content:center
    }
      }

  pc-form[form-type='search'] #edit-submit-newsroom, .pc-form[form-type='search'] #edit-submit-newsroom{
      left:var(--spacing-5);
    }

  @media (min-width: 992px){

  pc-form[form-type='search'] #edit-submit-newsroom, .pc-form[form-type='search'] #edit-submit-newsroom{
        padding:var(--spacing-0);
        left:27.5%
    }
      }

  pc-form[form-type='search'] input[type='text'],
    pc-form[form-type='search'] input[type='search'],
    .pc-form[form-type='search'] input[type='text'],
    .pc-form[form-type='search'] input[type='search']{
      padding-left:var(--spacing-16);
      font-size:var(--fs-h5-mobile);
      line-height:var(--lh-h5);
    }

  @media (min-width: 992px){

  pc-form[form-type='search'] input[type='text'],
    pc-form[form-type='search'] input[type='search'],
    .pc-form[form-type='search'] input[type='text'],
    .pc-form[form-type='search'] input[type='search']{
        font-size:var(--fs-h5);
        width:100%;
        width:var(--width-input-type-search, 100%)
    }
      }

  pc-form[form-type='search'] input[type='search']::-webkit-search-cancel-button, .pc-form[form-type='search'] input[type='search']::-webkit-search-cancel-button{
      background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cg id='Icon/Close'%3E%3Cpath id='Union' fill-rule='evenodd' clip-rule='evenodd' d='M8.99977 10.4155L15.8211 17.2368L17.2353 15.8226L10.414 9.0013L17.2354 2.17984L15.8212 0.765625L8.99977 7.58708L2.17831 0.765625L0.764099 2.17984L7.58556 9.0013L0.764248 15.8226L2.17846 17.2368L8.99977 10.4155Z' fill='%237A6E87'/%3E%3C/g%3E%3C/svg%3E");
      background-size:cover;
      background-repeat:no-repeat;
      position:relative;
      cursor:pointer;
      -webkit-appearance:none;
      height:var(--spacing-4);
      width:var(--spacing-4);
    }

  pc-form[form-type='search'] .btn-search,
    pc-form[form-type='search'] input[type='submit'],
    .pc-form[form-type='search'] .btn-search,
    .pc-form[form-type='search'] input[type='submit']{
      font-size:0;
      position:absolute;
      top:9%;
      bottom:0;
      left:var(--spacing-4);
      display:flex;
      align-items:center;
      justify-content:center;
      width:48px;
      height:48px;
      background-image:url('data:image/svg+xml,%3Csvg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M14.8009 8.47652C14.8009 12.0704 11.9184 14.953 8.40045 14.953C4.88254 14.953 2 12.0704 2 8.47652C2 4.8826 4.88254 2 8.40045 2C11.9184 2 14.8009 4.8826 14.8009 8.47652ZM13.9055 14.8793C12.4312 16.1711 10.5063 16.953 8.40045 16.953C3.76101 16.953 0 13.158 0 8.47652C0 3.79507 3.76101 0 8.40045 0C13.0399 0 16.8009 3.79507 16.8009 8.47652C16.8009 10.3084 16.225 12.0046 15.2459 13.3907L24.3522 22.5794L22.9443 24L13.9055 14.8793Z" fill="%235B39B7"%3E%3C/path%3E%3C/svg%3E');
      background-position:center;
      background-repeat:no-repeat;
      background-color:transparent;
    }

  pc-form[form-type='search'] .btn-search:hover,
      pc-form[form-type='search'] .btn-search:focus,
      pc-form[form-type='search'] input[type='submit']:hover,
      pc-form[form-type='search'] input[type='submit']:focus,
      .pc-form[form-type='search'] .btn-search:hover,
      .pc-form[form-type='search'] .btn-search:focus,
      .pc-form[form-type='search'] input[type='submit']:hover,
      .pc-form[form-type='search'] input[type='submit']:focus{
        background-image:url('data:image/svg+xml,%3Csvg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath fill-rule="evenodd" clip-rule="evenodd" d="M14.8009 8.47652C14.8009 12.0704 11.9184 14.953 8.40045 14.953C4.88254 14.953 2 12.0704 2 8.47652C2 4.8826 4.88254 2 8.40045 2C11.9184 2 14.8009 4.8826 14.8009 8.47652ZM13.9055 14.8793C12.4312 16.1711 10.5063 16.953 8.40045 16.953C3.76101 16.953 0 13.158 0 8.47652C0 3.79507 3.76101 0 8.40045 0C13.0399 0 16.8009 3.79507 16.8009 8.47652C16.8009 10.3084 16.225 12.0046 15.2459 13.3907L24.3522 22.5794L22.9443 24L13.9055 14.8793Z" fill="%23361a4b"%3E%3C/path%3E%3C/svg%3E');
      }

  pc-form[form-type='search'] .btn-search[value='Reset'], pc-form[form-type='search'] input[type='submit'][value='Reset'], .pc-form[form-type='search'] .btn-search[value='Reset'], .pc-form[form-type='search'] input[type='submit'][value='Reset']{
        left:inherit;
        right:var(--spacing-4);
        background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cg id='Icon/Close'%3E%3Cpath id='Union' fill-rule='evenodd' clip-rule='evenodd' d='M8.99977 10.4155L15.8211 17.2368L17.2353 15.8226L10.414 9.0013L17.2354 2.17984L15.8212 0.765625L8.99977 7.58708L2.17831 0.765625L0.764099 2.17984L7.58556 9.0013L0.764248 15.8226L2.17846 17.2368L8.99977 10.4155Z' fill='%237A6E87'/%3E%3C/g%3E%3C/svg%3E");
      }

  pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block .btn-search,
      pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block input[type='submit'],
      .pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block .btn-search,
      .pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block input[type='submit']{
        top:25%;
      }

  @media (min-width: 992px){

  pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block .btn-search,
      pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block input[type='submit'],
      .pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block .btn-search,
      .pc-form[form-type='search'] #views-exposed-form-newsroom-newsroom-block input[type='submit']{
          top:35%
      }
        }

  @media (max-width: 992px){
      pc-form[form-type='search'] input[type='text'],
      pc-form[form-type='search'] input[type='search'],
      .pc-form[form-type='search'] input[type='text'],
      .pc-form[form-type='search'] input[type='search']{
        padding-left:var(--spacing-12);
        padding-top:var(--spacing-4);
        padding-bottom:var(--spacing-4);
      }

      pc-form[form-type='search'] .btn-search,
      pc-form[form-type='search'] input[type='submit'],
      .pc-form[form-type='search'] .btn-search,
      .pc-form[form-type='search'] input[type='submit']{
        left:0.5rem;
        background-size:1.25rem;
      }
    }

  pc-form[form-type='search'] input[data-drupal-selector='edit-submit-site-search-2'][type='submit'],
    pc-form[form-type='search'] input[data-drupal-selector='edit-submit-people-search-2'][type='submit'],
    .pc-form[form-type='search'] input[data-drupal-selector='edit-submit-site-search-2'][type='submit'],
    .pc-form[form-type='search'] input[data-drupal-selector='edit-submit-people-search-2'][type='submit']{
      top:0;
      width:60px;
      height:60px;
      left:0px;
    }

  @media (min-width: 992px){

  pc-form[form-type='search'] input[data-drupal-selector='edit-submit-site-search-2'][type='submit'],
    pc-form[form-type='search'] input[data-drupal-selector='edit-submit-people-search-2'][type='submit'],
    .pc-form[form-type='search'] input[data-drupal-selector='edit-submit-site-search-2'][type='submit'],
    .pc-form[form-type='search'] input[data-drupal-selector='edit-submit-people-search-2'][type='submit']{
        width:56px;
        height:56px;
        left:var(--spacing-2)
    }
      }

  pc-form .results-container-facets, .pc-form .results-container-facets{
    transform:translateY(var(--bottom-offset));
    flex-flow:wrap;
  }
`;